// frontend/src/pages/ContactUs.js

import React, { useState } from 'react';
import axiosInstance from '../utils/axiosConfig';
import { FaInstagram, FaFacebook, FaTiktok } from 'react-icons/fa';

const ContactUs = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState('');

  // Formular absenden => POST /api/contact
  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('');

    if (!name.trim() || !email.trim() || !subject.trim()) {
      setStatus('Bitte füllen Sie alle erforderlichen Felder aus.');
      return;
    }
    try {
      await axiosInstance.post('/contact', {
        name: name.trim(),
        email: email.trim(),
        subject: subject.trim(),
        message: message.trim(),
      });
      setStatus('Vielen Dank! Ihre Nachricht wurde gesendet.');
      setName('');
      setEmail('');
      setSubject('');
      setMessage('');
    } catch (err) {
      setStatus('Nachricht konnte nicht gesendet werden. Bitte versuchen Sie es später erneut.');
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-heading text-primary mb-4">Kontakt</h1>

      {status && (
        <div className="mb-4">
          <p
            className={
              status.startsWith('Vielen Dank!')
                ? 'text-green-600'
                : 'text-red-600'
            }
          >
            {status}
          </p>
        </div>
      )}

      <form onSubmit={handleSubmit} className="max-w-md space-y-4">
        <div>
          <label className="block font-semibold mb-1">Name:</label>
          <input
            type="text"
            className="w-full p-2 border rounded"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>
        <div>
          <label className="block font-semibold mb-1">E-Mail:</label>
          <input
            type="email"
            className="w-full p-2 border rounded"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div>
          <label className="block font-semibold mb-1">Betreff:</label>
          <input
            type="text"
            className="w-full p-2 border rounded"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            required
          />
        </div>
        <div>
          <label className="block font-semibold mb-1">Nachricht:</label>
          <textarea
            className="w-full p-2 border rounded"
            rows={4}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </div>

        <button
          type="submit"
          className="bg-primary text-white px-4 py-2 rounded hover:bg-orange-600"
        >
          Senden
        </button>
      </form>

      <hr className="my-8" />

      <div className="space-y-4">
        <p>
          <strong>Kontakt per E-Mail:</strong>{' '}
          <a
            href="mailto:info@entecity.ch"
            className="text-blue-600 underline"
          >
            info@entecity.ch
          </a>
        </p>
        <p>
          <strong>Telefon Nr:</strong> +41 79 660 51 51
        </p>

        <h2 className="text-xl font-heading text-primary mt-6">
          Finden Sie uns auf Social Media:
        </h2>
        <div className="flex items-center space-x-4">
          {/* Instagram */}
          <a
            href="https://instagram.com/entecity.ch"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram className="w-6 h-6 text-gray-600 hover:text-gray-800" />
          </a>
          {/* Facebook */}
          <a
            href="https://facebook.com/entecity.ch"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaFacebook className="w-6 h-6 text-gray-600 hover:text-gray-800" />
          </a>
          {/* TikTok */}
          <a
            href="https://tiktok.com/@entecity"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaTiktok className="w-6 h-6 text-gray-600 hover:text-gray-800" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
